export default "__VITE_ASSET__BhTWNUe$__"